import React from 'react'
import { usePlansContext } from '../../../../hooks/usePlansContext'
import { HeaderActionProps } from '../../../../types/headerActionProps'
import { ActionContent } from '../ActionContent'

export const FamilyAction = (props: HeaderActionProps) => {
  const { isFamilySelected, onClickFamily } = usePlansContext()

  return (
    <ActionContent
      isSelected={isFamilySelected}
      onClick={onClickFamily}
      {...props}
    />
  )
}
